export default function isNil(x: any): boolean {
  // x can be anything, string, number, boolean, object...
  // doesn't check if the object is empty, an empty object will return false!
  // use isObjectEmpty to check for empty objects!
  // See unit tests

  // x == null will return true which is 100% equivalent to (variable === undefined || variable === null) * not the equality check difference

  if (x == null || x.length === 0) {
    return true;
  }

  return false;
}
